import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'webstore-card-loader',
  templateUrl: './card-loader.component.html',
  styleUrls: ['./card-loader.component.scss'],
  imports: [CommonModule]
})
export class CardLoaderComponent {
  readonly diameter = input<string>('3');
}

